export default __webpack_public_path__ + "static/media/lupa.97968b87.svg";